export enum SttMarkerType {
  Hearing = 'hearing',
  Sealing = 'sealing',
  Session = 'session',
}
